import type { SVGProps } from 'react'

export const SvgPedestrian = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 40 40"
    fill="none"
    stroke="currentColor"
    strokeWidth={3.33333}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
    {...props}
  >
    <path d="M6.66676 26.6666V22.7C6.66676 19.1666 4.95009 17.5 5.00009 13.3333C5.05009 8.79998 7.48343 3.33331 12.5001 3.33331C15.6168 3.33331 16.6668 6.33331 16.6668 9.16665C16.6668 14.35 13.3334 18.6 13.3334 23.6333V26.6666C13.3334 27.5507 12.9822 28.3985 12.3571 29.0237C11.732 29.6488 10.8841 30 10.0001 30C9.11604 30 8.26819 29.6488 7.64307 29.0237C7.01795 28.3985 6.66676 27.5507 6.66676 26.6666Z" />
    <path d="M33.3335 33.3333V29.3667C33.3335 25.8333 35.0502 24.1667 35.0002 20C34.9502 15.4667 32.5168 10 27.5002 10C24.3835 10 23.3335 13 23.3335 15.8333C23.3335 21.0167 26.6668 25.2667 26.6668 30.3V33.3333C26.6668 34.2174 27.018 35.0652 27.6431 35.6904C28.2683 36.3155 29.1161 36.6667 30.0002 36.6667C30.8842 36.6667 31.7321 36.3155 32.3572 35.6904C32.9823 35.0652 33.3335 34.2174 33.3335 33.3333Z" />
    <path d="M26.6665 28.3333H33.3332" />
    <path d="M6.6665 21.6667H13.3332" />
  </svg>
)
